import Request from '@/plugins/request';

export function getBillBalanceLogs(params) {
  return Request.get('bill-balance-logs', { params })
}

export function createBillBalanceLog() {
  return Request.get(`bill-balance-logs/create`)
}

export function storeBillBalanceLog(data) {
  return Request.post('bill-balance-logs', data)
}

export function updateBillBalanceLog(id, data) {
  return Request.put(`bill-balance-logs/${id}`, data)
}

export function editBillBalanceLog(id) {
  return Request.get(`bill-balance-logs/${id}/edit`)
}

export function destroyBillBalanceLog(id) {
  return Request.delete(`bill-balance-logs/${id}`)
}
